import { render, staticRenderFns } from "./WorkspaceListHandler.vue?vue&type=template&id=06859267"
import script from "./WorkspaceListHandler.vue?vue&type=script&lang=ts"
export * from "./WorkspaceListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports